import { Button } from '@material-ui/core';
import React, { useState,useEffect } from 'react';
import firebase from "firebase/app";
import Webcam from "react-webcam";
import logo from './../rcrm_logo.png';
import { useHistory } from 'react-router-dom';
import './validate.css';
import { Container, Card, CardContent, Typography } from '@material-ui/core';

const ValidatePage = () => {
  var buttonfield = true;
  if (document.addEventListener) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);
  }
  const webcamRef = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState(null);
  const history = useHistory();

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    sessionStorage.setItem("imageSrc", imageSrc);
  }, [webcamRef]);

  if (imgSrc) {
    buttonfield = false;
  }

  const handleClick = () => {
    history.push("/systemcheck");
  };

  return (
    <div className="App">
      <img src={logo} alt="logo" className="App-logo" />
      
        <Container className="validate-container" maxWidth="lg">
        <Card className="validate-card" style={{ boxShadow: '0px 11px 35px 2px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
            <CardContent>
                <Typography variant="h5" align="center" className="instructions-title">
                 <b id="systemValidationInstructionsTxt">System Verification Requirements</b> 
                </Typography>
                
                <ol className="instructions-list" style={{ textAlign: 'left' }}>
                  <li>Ensure adequate lighting conditions equivalent to natural daylight for optimal image quality.</li>
                  <li>Position yourself in a well-illuminated area to enhance verification accuracy.</li>
                  <li>Select "Capture Photo" to initiate the verification process.</li>
                  <li>Review the captured image and proceed with "Confirm Verification" to continue.</li>
                </ol>

              <div className="webcam-container">
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  className="webcam"
                />
                {imgSrc && (
                  <img src={imgSrc} alt="Captured" className="captured-image" />
                )}
              </div>

              <div className="button-group">
                <Button variant="contained" color="primary" onClick={capture} className="capture-button">
                  Capture Photo
                </Button>
                <Button variant="contained" disabled={buttonfield} color="secondary" onClick={handleClick} >
                  Confirm Verification
                </Button>
              </div>
            </CardContent>
          </Card>
        </Container>
    </div>
  );
};

export default ValidatePage;
